import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import Chart from 'chart.js/auto';
import './PlatformChargesDonutChart.css';

const PlatformChargesDonutChart = ({ data, centerValue }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const ctx = chartRef.current.getContext('2d');

      const filteredData = data.filter(item => item.value > 0);

      // Prepare data for Chart.js
      const chartData = {
        labels: filteredData.map(item => item.label),
        datasets: [
          {
            data: filteredData.map(item => item.value),
            backgroundColor: [
              '#2563eb', // Blue - Klass Commission
              '#fbbf24', // Yellow - Service/Platform Fee
              '#10b981', // Green - Instructor Commission
            ].slice(0, filteredData.length),
            borderWidth: 0,
            cutout: '60%',
            borderRadius: 8,
            offset: 10,
          },
        ],
      };

      // Create the chart
      chartInstance.current = new Chart(ctx, {
        type: 'doughnut',
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: context => {
                  const label = context.label || '';
                  const value = context.raw || 0;
                  return `${label}: ${value} Koins`;
                },
              },
            },
          },
        },
        plugins: [
          {
            id: 'centerText',
            beforeDraw: chart => {
              const { ctx, chartArea } = chart;
              ctx.save();

              // Draw 'Total' text
              ctx.font = '14px Poppins';
              ctx.fillStyle = '#6b7280';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(
                'Total',
                chartArea.left + chartArea.width / 2,
                chartArea.top + chartArea.height / 2 - 10
              );

              // Draw centerValue
              ctx.font = '700 24px Poppins';
              ctx.fillStyle = '#111827';
              ctx.fillText(
                centerValue,
                chartArea.left + chartArea.width / 2,
                chartArea.top + chartArea.height / 2 + 15
              );

              ctx.restore();
            },
          },
        ],
      });
    }

    // Cleanup function
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, centerValue]);

  return (
    <Box className="platform-charges-donut-container">
      <Box className="platform-charges-donut-chart">
        <canvas ref={chartRef} />
      </Box>
      <Box className="platform-charges-donut-legend">
        {data
          .filter(item => item.value > 0)
          .map((item, index) => (
            <Box key={index} className="platform-charges-legend-item">
              <span className={`platform-charges-legend-dot color-${index + 1}`}></span>
              <Typography className="platform-charges-legend-text">{item.label}</Typography>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default PlatformChargesDonutChart;
